import concat from 'lodash/concat';
import delay from 'lodash/delay';
import kebabCase from 'lodash/kebabCase';
import map from 'lodash/map';
import React from 'react';
import PropTypes from 'prop-types';

import Block from './block';
import Picture from '../Picture';

import './blocks.scss';

const pulseClick = ({ currentTarget: el }) => {
  const callback = () => el.blur();
  delay(callback, 150);
};

class Blocks extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      wasVisibleIndex: Math.floor(Math.random() * props.blocks.length),
    };
    this.handleAnotherClick = this.handleAnotherClick.bind(this);
  }

  handleAnotherClick(event) {
    const { blocks } = this.props;
    const { wasVisibleIndex } = this.state;
    pulseClick(event);
    this.setState({
      wasVisibleIndex:
        wasVisibleIndex + 1 === blocks.length ? 0 : wasVisibleIndex + 1,
    });
  }

  render() {
    const { blocks } = this.props;
    const { wasVisibleIndex } = this.state;
    if (blocks.length > 1) {
      const orderedBlocks = concat(
        blocks.slice(wasVisibleIndex),
        blocks.slice(0, wasVisibleIndex)
      );
      return (
        <div className="blocks">
          <div className="items" style={{ width: 'calc(200% - 2rem)' }}>
            {map(orderedBlocks, (block, blockIndex) => (
              <Block
                {...block}
                key={kebabCase(block.title)}
                wasVisible={blockIndex === 0}
                willBeVisible={blockIndex === 1}
              />
            ))}
          </div>
          <nav className="block-navigation">
            <button type="button" onClick={this.handleAnotherClick}>
              <Picture
                alt="View Another [infinity icon]"
                filepath="ui/infinity"
              />
              <span className="sr-only">View Another</span>
            </button>
          </nav>
        </div>
      );
    }
    return null;
  }
}

Blocks.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object),
};

Blocks.defaultProps = {
  blocks: [],
};

export default Blocks;



// WEBPACK FOOTER //
// ./src/components/Blocks/index.js